import React, { useEffect, useState } from "react"
import Joyride, { CallBackProps } from "react-joyride"
import { PRIMARY } from "../../ui/Colors";
import { notificationsSteps } from "./steps/notifications";


enum Steps {
    NOTIFICATIONS,
}

const NotificationsProductTour = ({ setHasProductTour // not used but if you remove it, it doesn't work anymore :/   
}: { setHasProductTour: React.Dispatch<React.SetStateAction<boolean>> }) => {
    const [{ stepIndex, run, steps, type }, setProductTour] = useState({ stepIndex: 0, run: false, steps: notificationsSteps, type: Steps.NOTIFICATIONS })

    const handleNextStepClick = () => {
        setProductTour((data) => {
            return { stepIndex, run, steps: notificationsSteps, type }
        })
    }

    useEffect(() => {
        // Open product tour
        if (!localStorage.getItem('notificationsProductTour')) {
            setProductTour(data => ({ run: true, stepIndex, steps, type }));
            const notificationIcon = document.getElementById("openNotifications")

            // Add a listener to the notification icon
            if (notificationIcon) {
                notificationIcon.addEventListener('click', handleNextStepClick)
            }
        }
    }, [])

    const handleProductTourCallback = (data: CallBackProps) => {
        if (data.action === "stop") { // Close product tour and set the local storage
            setProductTour((data) => ({ stepIndex: 0, run: false, steps: notificationsSteps, type: data.type }))
            localStorage.setItem('notificationsProductTour', 'true')
        }
    };

    return <Joyride
        callback={handleProductTourCallback}
        continuous
        run={run}
        disableScrolling
        scrollToFirstStep
        hideBackButton
        showProgress
        showSkipButton
        steps={steps}
        stepIndex={stepIndex}
        styles={{
            options: {
                zIndex: 10000,
                primaryColor: PRIMARY,
                width: undefined,
            },
        }} />
}

export default NotificationsProductTour